import axIcon from './icons/ax.inline.svg';
import backpackIcon from './icons/backpack.inline.svg';
import iconBasket from './icons/basket.inline.svg';
import carabineIcon from './icons/carabine.inline.svg';
import iconChart from './icons/chart.inline.svg';
import iconCheck from './icons/check.inline.svg';
import okIcon from './icons/checkmark-circle-outline.inline.svg';
import iconSquareChecked from './icons/checkSquare.inline.svg';
import chevDownIcon from './icons/chevron-down-outline.inline.svg';
import chevUpIcon from './icons/chevron-up-outline.inline.svg';
import iconCircle from './icons/circle.inline.svg';
import iconClose from './icons/close.inline.svg';
import zipIcon from './icons/compress.inline.svg';
import cubeIcon from './icons/cube.inline.svg';
import downloadIcon from './icons/download.inline.svg';
import leafIcon from './icons/eco.inline.svg';
import iconFemale from './icons/female.inline.svg';
import filterOutline from './icons/filter-outline.inline.svg';
import fireIcon from './icons/flame.inline.svg';
import hourglassIcon from './icons/hourglass-outline.inline.svg';
import infoCircleIcon from './icons/info-circle.inline.svg';
import libraIcon from './icons/libra.inline.svg';
import lockIcon from './icons/lock.inline.svg';
import iconMale from './icons/male.inline.svg';
import mapIcon from './icons/map.inline.svg';
import openIcon from './icons/open-outline.inline.svg';
import pencilIcon from './icons/pencil.inline.svg';
import placeIcon from './icons/place.inline.svg';
import plusIcon from './icons/plus.inline.svg';
import iconPrinter from './icons/printer.inline.svg';
import puzzleIcon from './icons/puzzle.inline.svg';
import questionCircleIcon from './icons/question-circle.inline.svg';
import iconRefresh from './icons/refresh.inline.svg';
import dragIcon from './icons/reorder-three-outline.inline.svg';
import foodIcon from './icons/restaurant.inline.svg';
import rightMenuIcon from './icons/right-menu.inline.svg';
import saveIcon from './icons/save.inline.svg';
import searchIcon from './icons/search.inline.svg';
import cogIcon from './icons/settings-outline.inline.svg';
import iconShopping from './icons/shopping.inline.svg';
import iconSquare from './icons/square.inline.svg';
import starIcon from './icons/star-outline.inline.svg';
import likeIcon from './icons/thumb_up.inline.svg';
import trashIcon from './icons/trash.inline.svg';
import userIcon from './icons/user.inline.svg';
import iconWatch from './icons/watch.inline.svg';
import IconsEnum from './IconsEnum';

export function getIconSrc(name: IconsEnum) {
  switch (name) {
    case IconsEnum.plus:
      return plusIcon;
    case IconsEnum.trash:
      return trashIcon;
    case IconsEnum.pencil:
      return pencilIcon;
    case IconsEnum['menu-right']:
      return rightMenuIcon;
    case IconsEnum.save:
      return saveIcon;
    case IconsEnum.edit:
      return pencilIcon;
    case IconsEnum.download:
      return downloadIcon;
    case IconsEnum.leaf:
      return leafIcon;
    case IconsEnum.compressed:
      return zipIcon;
    case IconsEnum.lock:
      return lockIcon;
    case IconsEnum.user:
      return userIcon;
    case IconsEnum['thumbs-up']:
      return likeIcon;
    case IconsEnum.cutlery:
      return foodIcon;
    case IconsEnum['map-marker']:
      return placeIcon;
    case IconsEnum.globe:
      return mapIcon;
    case IconsEnum.success:
    case IconsEnum.ok:
      return okIcon;
    case IconsEnum.hourglass:
      return hourglassIcon;
    case IconsEnum.fire:
      return fireIcon;
    case IconsEnum.open:
      return openIcon;
    case IconsEnum.star:
      return starIcon;
    case IconsEnum.cog:
      return cogIcon;
    case IconsEnum.right_menu:
      return rightMenuIcon;
    case IconsEnum.drag:
      return dragIcon;
    case IconsEnum.chevron_down:
      return chevDownIcon;
    case IconsEnum.chevron_up:
      return chevUpIcon;
    case IconsEnum.education:
    case IconsEnum.resize:
      return puzzleIcon;
    case IconsEnum.help:
      return questionCircleIcon;
    case IconsEnum.info:
      return infoCircleIcon;
    case IconsEnum.filterOutline:
      return filterOutline;
    case IconsEnum.search:
      return searchIcon;
    case IconsEnum.libra:
      return libraIcon;
    case IconsEnum.cube:
      return cubeIcon;
    case IconsEnum.carabine:
      return carabineIcon;
    case IconsEnum.backpack:
      return backpackIcon;
    case IconsEnum.ax:
      return axIcon;
    case IconsEnum.close:
      return iconClose;
    case IconsEnum.watch:
      return iconWatch;
    case IconsEnum.check:
      return iconCheck;
    case IconsEnum.male:
      return iconMale;
    case IconsEnum.female:
      return iconFemale;
    case IconsEnum.chart:
      return iconChart;
    case IconsEnum.print:
      return iconPrinter;
    case IconsEnum.basket:
      return iconBasket;
    case IconsEnum.shopping:
      return iconShopping;
    case IconsEnum.square:
      return iconSquare;
    case IconsEnum.circle:
      return iconCircle;
    case IconsEnum.squareChecked:
      return iconSquareChecked;
    case IconsEnum.refresh:
      return iconRefresh;

    default:
      return puzzleIcon;
  }
}

export default { getIconSrc };
